export const CHANNEL = Object.freeze({
    SMS: 'sms',
    WHATSAPP: 'whatsapp',
    EMAIL: 'email',
});

export type ChannelValues = (typeof CHANNEL)[keyof typeof CHANNEL];
